import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-polarisatie',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconPolarisatie {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M33.04 31.04h-7.08c-1.65 0-2.96 1.25-2.96 2.8V35c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52m-7.05-5.53c0 1.94 1.57 3.51 3.51 3.51s3.51-1.57 3.51-3.51S31.44 22 29.5 22s-3.51 1.57-3.51 3.51m-15.95 5.53H2.96c-1.65 0-2.96 1.25-2.96 2.8V35c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52M6.5 29.01c1.94 0 3.51-1.57 3.51-3.51s-1.57-3.51-3.51-3.51-3.51 1.57-3.51 3.51 1.57 3.51 3.51 3.51M28 0H8a2 2 0 0 0-2 2v15c0 .5.19.94.48 1.29.37.43.91.71 1.52.71h4l.03 3.47c0 .2.12.38.31.46.06.03.13.04.19.04.13 0 .25-.05.35-.14l3.88-3.82h2.5l3.88 3.82c.1.09.22.14.35.14.06 0 .13-.01.19-.04.19-.08.31-.26.31-.46l.03-3.47h4c.61 0 1.15-.28 1.52-.71.3-.35.48-.8.48-1.29V2c0-1.11-.89-2-2-2Zm-6.32 8.3-4.41 6.77a1 1 0 0 1-.84.45h-.05c-.7 0-1.19-.71-.93-1.36l1.41-3.64h-2.13c-.33 0-.57-.32-.48-.64l1.65-5.64c.12-.43.52-.72.96-.72h2.93c.39 0 .63.42.43.75l-1.89 3.25h2.93c.4 0 .64.44.42.77Z"/>
</svg>

    );
  }
}
